(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-table-of-contents"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.article-guide-toc__mobile .article-guide-toc__link');
    if (!link || !window.matchMedia('(max-width: 999px)').matches) return;
    const details = link.closest('details');
    if (details) details.open = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-skintific"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => value.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

    const initialize = (root) => {
      if (root.dataset.sktReady === 'true') return;
      root.dataset.sktReady = 'true';
      const content = root.querySelector('[data-skt-article-content]');
      const links = [...root.querySelectorAll('[data-skt-toc-link]')];
      if (!content || links.length === 0) return;
      const headings = [...content.querySelectorAll('h2')];
      const observed = [];

      links.forEach((link) => {
        const id = link.getAttribute('href').slice(1);
        let heading = content.querySelector(`#${CSS.escape(id)}`);
        if (!heading) {
          const label = normalize(link.dataset.sktTargetLabel || '');
          heading = headings.find((item) => normalize(item.textContent || '') === label);
          if (heading && !heading.id) heading.id = id;
        }
        if (heading) observed.push({ heading, id });
      });

      if (!('IntersectionObserver' in window) || observed.length === 0) return;
      const setCurrent = (id) => {
        links.forEach((link) => {
          if (link.getAttribute('href') === `#${id}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setCurrent(visible[0].target.id);
      }, { rootMargin: '-18% 0px -68% 0px', threshold: 0 });
      observed.forEach(({ heading }) => observer.observe(heading));
    };

    document.querySelectorAll('[data-skt-article]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-skt-article]');
      if (root) initialize(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeComparison = (root) => {
      if (!root || root.dataset.comparisonInitialized === 'true') return;

      const track = root.querySelector('[data-comparison-track]');
      const previousButton = root.querySelector('[data-comparison-previous]');
      const nextButton = root.querySelector('[data-comparison-next]');
      if (!track || !previousButton || !nextButton) return;

      const updateControls = () => {
        const canScroll = track.scrollWidth > track.clientWidth + 2;
        previousButton.hidden = !canScroll;
        nextButton.hidden = !canScroll;
        previousButton.disabled = !canScroll || track.scrollLeft <= 2;
        nextButton.disabled = !canScroll || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };

      const scrollTrack = (direction) => {
        const amount = Math.max(track.clientWidth * 0.72, 220);
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      };

      previousButton.addEventListener('click', () => scrollTrack(-1));
      nextButton.addEventListener('click', () => scrollTrack(1));
      track.addEventListener('scroll', updateControls, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateControls).observe(track);
      } else {
        window.addEventListener('resize', updateControls);
      }

      root.dataset.comparisonInitialized = 'true';
      updateControls();
    };

    const initializeAllComparisons = (scope = document) => {
      scope.querySelectorAll('[data-product-comparison]').forEach(initializeComparison);
    };

    initializeAllComparisons();
    document.addEventListener('shopify:section:load', (event) => initializeAllComparisons(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
